'use client'

import { useAuthorization } from '@entities/authentication'
import { useSuspenseQuery } from '@tanstack/react-query'

import { tutorExclusionQueries } from '../api'

export const useExclusionListQuery = () => {
  const { bearerToken } = useAuthorization()

  return useSuspenseQuery({ ...tutorExclusionQueries.list({ bearerToken }) })
}

export const useRecentTutorsQuery = () => {
  const { bearerToken } = useAuthorization()

  return useSuspenseQuery({ ...tutorExclusionQueries.recentTutors({ bearerToken }) })
}
